import { IFormInputOption } from "@components/form/interfaces/form-interface";

export const socialMediaData = [
  { label: 'Facebook', lightIcon: '/assets/brand-guide/facebook-theme-light.png', darkIcon: '/assets/brand-guide/facebook-theme-dark.png' },
  { label: 'Instagram', lightIcon: '/assets/brand-guide/instagram-theme-light.png', darkIcon: '/assets/brand-guide/instagram-theme-dark.png' },
  { label: 'LinkedIn', lightIcon: '/assets/brand-guide/linkedin-theme-light.png', darkIcon: '/assets/brand-guide/linkedin-theme-dark.png' },
  { label: 'X', lightIcon: '/assets/brand-guide/x-theme-light.png', darkIcon: '/assets/brand-guide/x-theme-dark.png' },
  { label: 'TikTok', lightIcon: '/assets/brand-guide/tiktok-theme-light.png', darkIcon: '/assets/brand-guide/tiktok-theme-dark.png' },
  { label: 'YouTube', lightIcon: '/assets/brand-guide/youtube-theme-light.png', darkIcon: '/assets/brand-guide/youtube-theme-dark.png' }
]

export const segmentImages = [
  { key: 'Academias e Personal Trainers', value: '/assets/brand-guide/academias.webp', },
  { key: 'Agências de Marketing Digital', value: '/assets/brand-guide/agencia-de-marketing.webp', },
  { key: 'Agências de Viagens e Turismo', value: '/assets/brand-guide/agencia-de-viagem.webp', },
  { key: 'Agronegócio e Agropecuária', value: '/assets/brand-guide/agro.webp', },
  { key: 'Arquitetura e Design de Interiores', value: '/assets/brand-guide/arquitetura-e-design.webp', },
  { key: 'Artes Digitais', value: '/assets/brand-guide/arte-digital.webp', },
  { key: 'Artesanato e Artes Manuais', value: '/assets/brand-guide/artesanato.webp', },
  { key: 'Bares e Casas Noturnas', value: '/assets/brand-guide/bares.webp', },
  { key: 'Beleza e Estética', value: '/assets/brand-guide/moda.webp', },
  { key: 'Canais de Notícias Online', value: '/assets/brand-guide/jornalismo.webp', },
  { key: 'Clínicas e Consultórios Médicos', value: '/assets/brand-guide/medicos.webp', },
  { key: 'Comércio Eletrônico', value: '/assets/brand-guide/ecommerce.webp', },
  { key: 'Consultorias', value: '/assets/brand-guide/consultoria.webp', },
  { key: 'Desenvolvimento de Software e Aplicativos', value: '/assets/brand-guide/desenvolvimento.webp', },
  { key: 'Educação e Cursos Online', value: '/assets/brand-guide/curso-online.webp', },
  { key: 'Eventos e Entretenimento', value: '/assets/brand-guide/eventos.webp', },
  { key: 'Fábrica, Indústrias e Laboratórios', value: '/assets/brand-guide/industria.webp', },
  { key: 'Farmácias e Drogarias', value: '/assets/brand-guide/farmacia.webp', },
  { key: 'Hotéis e Pousadas', value: '/assets/brand-guide/pousada.webp', },
  { key: 'Imobiliárias', value: '/assets/brand-guide/imobiliaria.webp', },
  { key: 'Influenciadores Digitais', value: '/assets/brand-guide/influencer.webp', },
  { key: 'Logística', value: '/assets/brand-guide/logistica.webp', },
  { key: 'Mentorias e Especializações', value: '/assets/brand-guide/mentoria.webp', },
  { key: 'Organizações Não Governamentais (ONGs)', value: '/assets/brand-guide/ong.webp', },
  { key: 'Representações Comerciais', value: '/assets/brand-guide/comercial.webp', },
  { key: 'Recursos Humanos', value: '/assets/brand-guide/rh.webp', },
  { key: 'Restaurantes e Cafés', value: '/assets/brand-guide/restaurantes.webp', },
  { key: 'Saúde e Bem-estar', value: '/assets/brand-guide/saude.webp', },
  { key: 'Seguros', value: '/assets/brand-guide/seguros.webp', },
  { key: 'Serviços de Marketing e Mídias', value: '/assets/brand-guide/marketing-e-midia.webp', },
  { key: 'Serviços de Transporte', value: '/assets/brand-guide/transporte.webp', },
  { key: 'Serviços Financeiros e Fintechs', value: '/assets/brand-guide/financeiro.webp', },
  { key: 'Serviços Jurídicos', value: '/assets/brand-guide/juridico.webp' },
]

export const brandGuideSegment: IFormInputOption[] = [
  { label: 'Academias e Personal Trainers', value: 'Academias e Personal Trainers' },
  { label: 'Agências de Marketing Digital', value: 'Agências de Marketing Digital' },
  { label: 'Agências de Viagens e Turismo', value: 'Agências de Viagens e Turismo' },
  { label: 'Agronegócio e Agropecuária', value: 'Agronegócio e Agropecuária' },
  { label: 'Arquitetura e Design de Interiores', value: 'Arquitetura e Design de Interiores' },
  { label: 'Artes Digitais', value: 'Artes Digitais' },
  { label: 'Artesanato e Artes Manuais', value: 'Artesanato e Artes Manuais' },
  { label: 'Bares e Casas Noturnas', value: 'Bares e Casas Noturnas' },
  { label: 'Beleza e Estética', value: 'Beleza e Estética' },
  { label: 'Canais de Notícias Online', value: 'Canais de Notícias Online' },
  { label: 'Clínicas e Consultórios Médicos', value: 'Clínicas e Consultórios Médicos' },
  { label: 'Comércio Eletrônico', value: 'Comércio Eletrônico' },
  { label: 'Consultorias', value: 'Consultorias' },
  { label: 'Desenvolvimento de Software e Aplicativos', value: 'Desenvolvimento de Software e Aplicativos' },
  { label: 'Educação e Cursos Online', value: 'Educação e Cursos Online' },
  { label: 'Eventos e Entretenimento', value: 'Eventos e Entretenimento' },
  { label: 'Fábricas, Indústrias e Laboratórios', value: 'Fábricas, Indústrias e Laboratórios' },
  { label: 'Farmácias e Drogarias', value: 'Farmácias e Drogarias' },
  { label: 'Hotéis e Pousadas', value: 'Hotéis e Pousadas' },
  { label: 'Imobiliárias', value: 'Imobiliárias' },
  { label: 'Influenciadores Digitais', value: 'Influenciadores Digitais' },
  { label: 'Logística', value: 'Logística' },
  { label: 'Mentorias e Especializações', value: 'Mentorias e Especializações' },
  { label: 'Organizações Não Governamentais (ONGs)', value: 'Organizações Não Governamentais (ONGs)' },
  { label: 'Representações Comerciais', value: 'Representações Comerciais' },
  { label: 'Recursos Humanos', value: 'Recursos Humanos' },
  { label: 'Restaurantes e Cafés', value: 'Restaurantes e Cafés' },
  { label: 'Saúde e Bem-estar', value: 'Saúde e Bem-estar' },
  { label: 'Seguros', value: 'Seguros' },
  { label: 'Serviços de Marketing e Mídias', value: 'Serviços de Marketing e Mídias' },
  { label: 'Serviços de Transporte', value: 'Serviços de Transporte' },
  { label: 'Serviços Financeiros e Fintechs', value: 'Serviços Financeiros e Fintechs' },
  { label: 'Serviços Jurídicos', value: 'Serviços Jurídicos' },
]

export const voiceToneData: IFormInputOption[] = [
  { label: "Acolhedor", value: "Acolhedor" },
  { label: "Amigável", value: "Amigável" },
  { label: "Autoritário", value: "Autoritário" },
  { label: "Confiante", value: "Confiante" },
  { label: "Descontraído", value: "Descontraído" },
  { label: "Direto", value: "Direto" },
  { label: "Divertido", value: "Divertido" },
  { label: "Elegante", value: "Elegante" },
  { label: "Empático", value: "Empático" },
  { label: "Especializado", value: "Especializado" },
  { label: "Inspirador", value: "Inspirador" },
  { label: "Inovador", value: "Inovador" },
  { label: "Moderno", value: "Moderno" },
  { label: "Motivador", value: "Motivador" },
  { label: "Objetivo", value: "Objetivo" },
  { label: "Profissional", value: "Profissional" },
  { label: "Sério", value: "Sério" },
  { label: "Sofisticado", value: "Sofisticado" },
  { label: "Técnico", value: "Técnico" }
];

export const personalityData: IFormInputOption[] = [
  { label: "Ambiciosa", value: "Ambiciosa" },
  { label: "Autêntica", value: "Autêntica" },
  { label: "Aventureira", value: "Aventureira" },
  { label: "Cativante", value: "Cativante" },
  { label: "Clássica", value: "Clássica" },
  { label: "Confiável", value: "Confiável" },
  { label: "Criativa", value: "Criativa" },
  { label: "Descolada", value: "Descolada" },
  { label: "Determinada", value: "Determinada" },
  { label: "Encantadora", value: "Encantadora" },
  { label: "Humilde", value: "Humilde" },
  { label: "Inovadora", value: "Inovadora" },
  { label: "Inteligente", value: "Inteligente" },
  { label: "Jovem", value: "Jovem" },
  { label: "Perspicaz", value: "Perspicaz" },
  { label: "Refinada", value: "Refinada" },
  { label: "Sofisticada", value: "Sofisticada" },
  { label: "Tradicional", value: "Tradicional" }
];
